// 卓の連結(卓グループ)の識別色。
// 超過表示(赤/黄)と被らない色だけを使い、サーバが返す colorIndex で引く。
// 色数はサーバ側 TableGroup::COLOR_COUNT と揃える
export const TABLE_GROUP_COLORS = [
  '#26A69A', // teal
  '#29B6F6', // blue
  '#EC407A', // pink
  '#66BB6A', // green
  '#26C6DA', // cyan
]

export const tableGroupColor = colorIndex => {
  const idx = Number.isInteger(colorIndex) ? colorIndex : 0

  return TABLE_GROUP_COLORS[((idx % TABLE_GROUP_COLORS.length) + TABLE_GROUP_COLORS.length) % TABLE_GROUP_COLORS.length]
}

// hall.attributes.tableGroups.data(JSONAPI)から、卓番号→所属情報を引くためのヘルパ
export const findParentGroup = (groups, tableNumber) => (groups || []).find(
  g => Number(g.attributes.parentTableNumber) === Number(tableNumber),
) || null

export const findChildGroup = (groups, tableNumber) => (groups || []).find(
  g => (g.attributes.tableNumbers || []).some(n => Number(n) === Number(tableNumber)),
) || null

// 卓名の表示(親卓番号の列挙などに使う)
export const formatTableNumbers = (tableNumbers, { prefix = '', suffix = '卓' } = {}) => (tableNumbers || [])
  .map(n => `${prefix}${n}${suffix}`)
  .join('・')
